import React, { useState } from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { ListingType } from '@utils/types/listing';
import WysiwygText from '@components/_shared/wysiwygText';

const defaultPolicy = [
  {
    question: '1 To 3 Month Stay Length',
    answerRaw:
      'A refundable credit card hold is required to cover any property damage during your stay. This hold will be placed 48 hours before your arrival. <br/> <br/>' +
      '<strong>Stays of 89 Nights or Less.</strong> $2,500 credit card hold upon check-in. <br/> <br/>' +
      '<strong>Hold and Release Information.</strong> <br/>' +
      '<ul>' +
      '<li>The hold will be released within 2 days after check-out if no damages or unpaid charges are found.</li>' +
      '<li>Replacement holds will be made every 7 days until released 48 hours after departure. It may take 3-5 business days to reflect in your account after release.</li>' +
      '<li>Cash security deposits will be reimbursed within 7 days if no damages or unpaid charges are observed during the first inspection, typically within 72 hours of check-out.</li>' +
      '</ul>',
  },
  {
    question: '3 To 6 Month Stay Length',
    answerRaw:
      'A refundable credit card hold is required to cover any property damage during your stay. This hold will be placed 48 hours before your arrival. <br/> <br/>' +
      '<strong>Stays of 90 to 179 Nights:</strong> $5,000 credit card hold upon check-in. <br/> <br/>' +
      '<strong>Hold and Release Information:</strong> <br/>' +
      '<ul>' +
      '<li>The hold will be released within 2 days after check-out if no damages or unpaid charges are found.</li>' +
      '<li>Replacement holds will be made every 7 days until released 48 hours after departure. It may take 3-5 business days to reflect in your account after release.</li>' +
      '<li>Cash security deposits will be reimbursed within 7 days if no damages or unpaid charges are observed during the first inspection, typically within 72 hours of check-out.</li>' +
      '</ul>',
  },
  {
    question: '6+ Month Stay Length',
    answerRaw:
      'A cash security deposit equivalent to 1 month’s rent is required to cover any property damage during your stay. <br/> <br/>' +
      '<strong>Stays of 6 Months (180 Nights) or Longer.</strong> One month’s rent as a cash security deposit, payable via bank transfer. <br/> <br/>' +
      '<strong>Hold and Release Information.</strong> <br/>' +
      'Cash security deposits will be reimbursed within 14 days if no damages or unpaid charges are outstanding. For more information on security deposit holding accounts or other long-term security deposit procedures questions, please contact our team directly.',
  },
];

type Props = {
  securityDepositPolicy?: ListingType['securityDepositPolicy'];
} & BaseComponentProps;

const SecurityDepositPolicy = (props: Props) => {
  const [selectedItem, setSelectedItem] = useState<number | null>(null);

  const onItemClick = (index: number) => {
    if (index === selectedItem) {
      setSelectedItem(null);
    } else {
      setSelectedItem(index);
    }
  };

  return (
    <div className={clsx([styles.securityDeposit, props.containerStyle])}>
      {(props.securityDepositPolicy?.length
        ? props.securityDepositPolicy
        : defaultPolicy
      ).map((f, index) => (
        <div
          key={index}
          className={clsx([styles.item, selectedItem === index && styles.open])}
          onClick={() => onItemClick(index)}
        >
          <div className={styles.item__question}>{f.question}</div>
          {props.securityDepositPolicy?.length ? (
            <WysiwygText
              containerStyle={styles.item__answer}
              content={f.answerRaw}
            />
          ) : (
            <div
              className={styles.item__answer}
              dangerouslySetInnerHTML={{ __html: f.answerRaw }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default SecurityDepositPolicy;
